import React from "react";

import { useTranslation } from "react-i18next";

import { useGlobalFilter } from "@/shared/hooks";

import {
    StyledEnvironmentSwitch,
    StyledEnvironmentSwitchContainer,
    StyledEnvironmentSwitchLabelPrivate,
    StyledEnvironmentSwitchLabelPro,
} from "./styled";

const switchClasses = {
    switchBase: "switchBase",
    checked: "checked",
    thumb: "thumb",
    track: "track",
};

const EnvironmentSwitch = () => {
    const { t } = useTranslation();
    const { isProEnvironment, setIsProEnvironment } = useGlobalFilter();

    if (isProEnvironment === null) {
        return <></>;
    }

    return (
        <StyledEnvironmentSwitchContainer>
            <StyledEnvironmentSwitchLabelPrivate $active={!isProEnvironment}>
                {t("Common.Private")}
            </StyledEnvironmentSwitchLabelPrivate>
            <StyledEnvironmentSwitch
                color="primary"
                classes={switchClasses}
                onChange={() => setIsProEnvironment(!isProEnvironment)}
                checked={isProEnvironment}
                inputProps={{
                    "aria-label": t("Common.Filter"),
                    // Necessary, waiting https://github.com/mui/material-ui/issues/34154 then remove
                    // @ts-ignore
                    "data-testid": `environment_switch-input`,
                }}
            />
            <StyledEnvironmentSwitchLabelPro $active={isProEnvironment}>
                {t("Common.Pro")}
            </StyledEnvironmentSwitchLabelPro>
        </StyledEnvironmentSwitchContainer>
    );
};

export default EnvironmentSwitch;
